import React, { useEffect } from 'react';

function Gastronomie() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main id="main-content" role="main">
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">
                Gastronomie <span className="hero__highlight">Recruiting Berlin</span>
              </h1>
              <p className="hero__subtitle">
                Personalgewinnung für Gastronomie in Berlin: Köche, Servicekräfte, Manager über Social Media. Authentische Inhalte und lokale Netzwerke seit 2009.
              </p>
              <div className="hero__cta">
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Hero CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Gastronomie Recruiting: Leidenschaft für gutes Personal in Berlin</h2>
            <p className="section-subtitle">
              Die Gastronomie-Szene in Berlin ist lebendig und vielfältig. Bei famefact spezialisieren wir uns auf Recruiting für Restaurants, Bars und Hotels über Social Media – von Köchen bis zu Servicekräften.
            </p>
          </div>

          <div className="content-grid">
            <div className="content-text">
              <h3>Warum Gastronomie-Recruiting in Berlin über Social Media erfolgreich ist</h3>
              <p>
                Berlin ist eine der aufregendsten kulinarischen Metropolen Europas. Mit über 8.000 Restaurants, 2.500 Bars und unzähligen Cafés ist die Gastronomie-Szene vielfältig wie nirgendwo sonst. Der Fachkräftemangel ist dramatisch: Über 70% der Gastronomen berichten von Schwierigkeiten bei der Mitarbeitersuche.
              </p>
              <p>
                Social Media ist der Game-Changer. Unsere Strategie basiert auf: <strong>Visuell begeisternde Inhalte, authentische Einblicke in die Team-Kultur und emotionale Storytelling.</strong> Köche, Bartender und Servicekräfte sind visuelle Menschen mit Leidenschaft für ihr Handwerk.
              </p>

              <div className="stats-grid">
                <div className="stat-box">
                  <span className="stat-box__number">10-18€</span>
                  <span className="stat-box__label">Pro Bewerbung</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">8.000+</span>
                  <span className="stat-box__label">Restaurants</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">2.500+</span>
                  <span className="stat-box__label">Bars</span>
                </div>
                <div className="stat-box">
                  <span className="stat-box__number">70%</span>
                  <span className="stat-box__label">Haben Personalmangel</span>
                </div>
              </div>

              <h3>Unsere Gastronomie Recruiting Services</h3>
              
              <h4>1. Köche und Küchenpersonal</h4>
              <ul>
                <li>Küchenchefs und Sous-Chefs</li>
                <li>Line Cooks und Prep Cooks</li>
                <li>Patissiers und Bäcker</li>
                <li>Küchenhilfen und Auszubildende</li>
              </ul>

              <h4>2. Servicepersonal und Front-of-House</h4>
              <ul>
                <li>Kellner und Servicekräfte</li>
                <li>Bartender und Baristas</li>
                <li>Hosts und Hostessen</li>
                <li>Sommeliers und Weinberater</li>
              </ul>

              <h4>3. Management und Administration</h4>
              <ul>
                <li>Restaurant Manager</li>
                <li>Kitchen Manager</li>
                <li>Operations Manager</li>
                <li>Event Manager</li>
              </ul>

              <div className="cta-box">
                <h3>Kostenlose Gastronomie-Analyse</h3>
                <p>Vereinbaren Sie Ihre kostenlose Analyse für Gastronomie-Recruiting.</p>
                <button className="btn btn--primary btn--large" data-open-consultation data-source="Content CTA">Kostenloses Erstgespräch</button>
              </div>
            </div>

            <div className="content-sidebar">
              <div className="sidebar-widget">
                <h3>Gastronomie-Positionen</h3>
                <ul>
                  <li>✓ Köche</li>
                  <li>✓ Servicekräfte</li>
                  <li>✓ Bartender</li>
                  <li>✓ Manager</li>
                  <li>✓ Küchenhilfen</li>
                </ul>
              </div>

              <div className="sidebar-widget">
                <h3>Kontakt</h3>
                <p>
                  famefact Social Recruiting Berlin<br />
                  Schliemannstraße 23<br />
                  10437 Berlin<br />
                  <a href="tel:+4930403665430">030 403 665 430</a><br />
                  <a href="mailto:info@famefact.com">info@famefact.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Gastronomie;
